import React from "react";
import "./WelcomePanel.css";

export default function WelcomePanel({ onStart }) {
  const suggestions = [
    {
      icon: "📚",
      title: "Explain",
      prompt: "Explain the concept of"
    },
    {
      icon: "🧮",
      title: "Math",
      prompt: "Solve this math problem:"
    },
    {
      icon: "🎯",
      title: "MCQ",
      prompt: "Generate MCQs for"
    },
    {
      icon: "📝",
      title: "Paper",
      prompt: "Generate a question paper for"
    }
  ];

  return (
    <div className="welcome-page">

      <div className="hero">

        <div className="logo-circle">
          🎓
        </div>

        <h1>
          What do you want to learn today?
        </h1>

        <p>
          Your AI study companion for school,
          NEET, JEE, UPSC and competitive exams.
        </p>

      </div>

      <div className="quick-subjects">

        <button onClick={() => onStart("Teach me Mathematics")}>
          📐 Maths
        </button>

        <button onClick={() => onStart("Teach me Science")}>
          🧪 Science
        </button>

        <button onClick={() => onStart("Teach me English")}>
          📖 English
        </button>

        <button onClick={() => onStart("Help me prepare for NEET")}>
          🏆 NEET
        </button>

      </div>

      <div className="action-grid">

        {suggestions.map((item, index) => (
          <button
            key={index}
            className="action-card"
            onClick={() => onStart(item.prompt)}
          >
            <div className="action-icon">
              {item.icon}
            </div>

            <div className="action-title">
              {item.title}
            </div>
          </button>
        ))}

      </div>

      

    </div>
  );
}